import validateVar from "./validation/validateVariable";

function get_load_profile_synthetic_info(is_synthetic, type) {
    if(!validateVar(is_synthetic)) return null;
    if (type === "text") return (+is_synthetic  === 0) ? "vorhanden" : "nicht vorhanden";
    else if (type === "color") return (+is_synthetic === 0) ? "green" : "red";
}

export default get_load_profile_synthetic_info;
